import AbstractApiService from 'src/services/abstractApiService';
import { DOC2API_URL } from 'pages/APIs';
import axios from 'axios';
import { getOrgId } from 'src/utils/organization/org_id_helper';

export default class SupplierRegistrationReferenceDocumentsApiService extends AbstractApiService {
  public constructor({}) {
    super({});
  }

  public async upload(file: any): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    return super.post(DOC2API_URL + '/supplier_document/create', formData);
  }

  public async getFile(): Promise<any> {
    return super.get(DOC2API_URL + '/supplier_document/list');
  }

  public async delete(id: string): Promise<any> {
    return super.delete(`${DOC2API_URL}/supplier_document/delete/${id}`, {});
  }

  public async previewFile(data: any): Promise<any> {
    return axios.get(
      `${DOC2API_URL}/resource/get_file/${data.id as string}?path=${data.path as string}&download=false&token=${data.token as string}&org_id=${getOrgId()}`,
      {
        responseType: 'blob',
      },
    );
  }
}
